import { render } from "./WArticulosBaja.vue?vue&type=template&id=4cc650bd&scoped=true"
import script from "./WArticulosBaja.vue?vue&type=script&lang=js"
export * from "./WArticulosBaja.vue?vue&type=script&lang=js"

import "./WArticulosBaja.vue?vue&type=style&index=0&id=4cc650bd&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc650bd"]])

export default __exports__